// extracted by mini-css-extract-plugin
module.exports = {"tableStyle":"CommissionBonus-module--tableStyle--3R8fh","range":"CommissionBonus-module--range--3zm2V"};